import React from 'react';
import Lottie from 'react-lottie';
import * as MapPinLoadingAnimation from '../../assets/lottie-pin-jumps.json';

export default function Loader() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: (MapPinLoadingAnimation as any).default,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    return (
        <div>
            <Lottie
                options={defaultOptions}
                height={400}
                width={400}
            />
        </div>
    );
}
